import styled from 'styled-components';
import {
    Snackbar as MUISnackbar,
    SnackbarProps,
    IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { colors } from 'constants/colors';

interface IProps extends SnackbarProps {
    onClose: () => void;
}

const BaseSnackbar = ({ message, onClose, ...other }: IProps) => (
    <MUISnackbar
        action={
            <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={onClose}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        }
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        message={message}
        onClose={onClose}
        {...other}
    />
);

export const Snackbar = styled(BaseSnackbar)`
    .MuiSnackbarContent-root {
        background-color: ${colors.greyMedium};
        color: ${colors.black};
        font-weight: 700;
    }
`;
